import * as R from 'ramda';

export default function EditUserDialogController(
  $rootScope,
  $scope,
  alerts,
  confirmDialog,
  ssDialogService,
  loaderService,
  userService,
  orgDataService
) {
  const vm = this;

  vm.customerHasCustomerTicketManager = false;
  vm.customerTypeId = -1;

  vm.handleCloseDialogClick = handleCloseDialogClick;
  vm.handleSaveUserFormSubmit = handleSaveUserFormSubmit;
  vm.handleSendInviteChange = handleSendInviteChange;
  vm.handleResendAzureInviteClick = _handleResendAzureInviteClick;
  vm.handleLoginNameChange = _handleLoginNameChange;
  vm.handleEmailAddressChange = _handleEmailAddressChange;
  vm.appIsLoaded = false;

  _activate();

  /** **************************************
   * Event Handlers
   */

  function handleSaveUserFormSubmit() {
    if ($scope.editUserForm.$valid) {
      loaderService.showViewLoader = true;
      let checkLoginNameExist = false;
      if (vm.user.authenticationSource === 'None') {
        vm.user.loginName = '';
      } else if (vm.user.authenticationSource === 'ActiveDirectory') {
        vm.user.authenticationSource = 'None';
      } else if (vm.user.authenticationSource === 'azureactivedirectory') {
        if (vm.permissions.canChangeLoginName === true || (vm.isNonAuthen === true)) {
          _handleLoginNameChange();
        }
        checkLoginNameExist = true;
      }
      if (checkLoginNameExist === true) {
        let _userId = 0;
        if (vm.userId > 0) {
          _userId = vm.userId;
        }
        orgDataService.checkLoginNameExists(_userId, vm.user.loginName).then((response) => {
          if (response.data === false) {
            alerts.error('Error occurred while checking login name exist.');
            loaderService.showViewLoader = false;
          } else if (response.data.result === false) {
            saveUserInfo();
          } else {
            alerts.error('Error occurred because login name already exists. Please change email address');
            loaderService.showViewLoader = false;
          }
        });
      } else {
        saveUserInfo();
      }
    }
  }

  function saveUserInfo() {
    if (vm.user.firstName.trim() !== '' && vm.user.lastName.trim() !== '') {
      vm.user.fullName = `${vm.user.firstName.trim()} ${vm.user.lastName.trim()}`;
    }
    const dfdUpdateUser = orgDataService.updateUser(vm.user);

    dfdUpdateUser.then((user) => {
      const userId = user.data.userId;

      $rootScope.$broadcast('refreshUsers');
      const arrCheckedRoles = R.filter(R.propEq('userHasAccess', true), vm.userRoles);

      // Ensure that, if the user has a role assigned, that the customer user role is also assigned
      if ((arrCheckedRoles) && (arrCheckedRoles.length > 0)) {
        if (vm.customerTypeId === 1) {
          const foundCustUserRole = R.filter(R.propEq('kenticoRoleName', 'ClientPortal_CustomerUser'), arrCheckedRoles);

          if (!foundCustUserRole || (foundCustUserRole.length === 0)) {
            const custUserRole = R.filter(R.propEq('kenticoRoleName', 'ClientPortal_CustomerUser'), vm.userRoles);
            custUserRole[0].userHasAccess = true;
            arrCheckedRoles.push(custUserRole[0]);
          }
        } else if (vm.customerTypeId === 3) {
          const foundCustUserRole = R.filter(R.propEq('kenticoRoleName', 'ClientPortal_CustomerUserNavanta'), arrCheckedRoles);

          if (!foundCustUserRole || (foundCustUserRole.length === 0)) {
            const custUserRole = R.filter(R.propEq('kenticoRoleName', 'ClientPortal_CustomerUserNavanta'), vm.userRoles);
            custUserRole[0].userHasAccess = true;
            arrCheckedRoles.push(custUserRole[0]);
          }
        }
      }

      orgDataService.assignUserRoles(userId, arrCheckedRoles)
        .then((response) => {
          loaderService.showViewLoader = false;
          if (response.data === false) {
            alerts.error('Error occurred while saving user.');
          } else {
            alerts.success('User has been saved successfully.');
          }
          _closeDialog();
        });
    }, () => {
      loaderService.showViewLoader = false;
      alerts.error('Error occurred while saving user.');
    });
  }

  function handleCloseDialogClick() {
    _closeDialog();
  }

  /** **************************************
   * Private Functions
   */

  function _activate() {
    loaderService.showViewLoader = true;
    return _initPermissions().then(() => {
      orgDataService.getCustomer(vm.user.customerId).then((response) => {
        vm.customerHasCustomerTicketManager = response.data.canDoSalesforceTicketing;
        vm.customerTypeId = response.data.customerTypeId;
        vm.appIsLoaded = true;
        loaderService.showViewLoader = false;
        vm.loaderService = loaderService;
        if (vm.isAzureAuthen === true) {
          vm.sendInvite = true;
          parseEmailAddress(vm.user.emailAddress);
          parseLoginName(vm.user.loginName);
        }
      });
    });
  }

  function _initPermissions() {
    return userService.getUserPermissionSet('admin').then((permissions) => {
      vm.permissions = permissions;
      vm.hasNavantaRoles = _hasRoleType(vm.userRoles, 'Navanta');
      vm.hasCustomerRoles = _hasRoleType(vm.userRoles, 'Customer');
    });
  }

  function _hasRoleType(roles, roleType) {
    if (roleType === 'Navanta') {
      const navantaRoles = R.filter(
        R.propEq('isNavantaRole', true),
        roles
      );
      console.log(navantaRoles);
      return navantaRoles.length > 0;
    }
    const customerRoles = R.filter(
      R.propEq('isCustomerRole', true),
      roles
    );

    return customerRoles.length > 0;
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.admin.userAdministation_editUserDialog);
  }

  function handleSendInviteChange() {
    if (vm.sendInvite === true) {
      vm.user.isActive = true;
      vm.user.authenticationSource = 'azureactivedirectory';
      if (vm.isNonAuthen === true) {
        vm.user.loginName = vm.user.emailAddress;
        parseEmailAddress(vm.user.emailAddress);
        parseLoginName(vm.user.loginName);
      } else {
        parseEmailAddress(vm.user.loginName);
        parseLoginName(vm.user.loginName);
      }
    } else if (vm.isNonAuthen === true) {
      vm.user.authenticationSource = 'None';
      vm.user.loginName = '';
      vm.user.isActive = false;
    } else if (vm.isADAuthen === true) {
      vm.user.authenticationSource = 'ActiveDirectory';
      vm.user.isActive = true;
    }
  }

  function _handleResendAzureInviteClick($event) {
    ssDialogService.dialogs.admin.userAdministation_resendInviteDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Resend Azure Login Invite',
        message: 'Are you sure you want to resend Azure login invite?',
        handleYesClick: () => {
          _handleYesResendDialog();
        },
        handleNoClick: () => {
          _handleNoResendDialog();
        }
      })
    );
    ssDialogService.show(ssDialogService.dialogs.admin.userAdministation_resendInviteDialog);
  }

  // Transfer Qualified Alert
  function _handleNoResendDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.admin.userAdministation_resendInviteDialog);
  }

  function _handleYesResendDialog() {
    loaderService.showViewLoader = true;
    orgDataService.sendAzureInvite(
      vm.user
    ).then((response) => {
      if (response.status !== 200) {
        alerts.error('Error occurred while sending user invite.');
      } else {
        alerts.success('User azure login invite is sent successfully.');
      }
      _handleNoResendDialog();
      loaderService.showViewLoader = false;
    });
  }

  function _handleLoginNameChange() {
    if (vm.customerHasUnverifiedEmailDomain) {
      if (vm.loginNamePrefix.trim() !== '' && vm.domainAddress.trim() !== '') {
        vm.user.loginName = `${vm.loginNamePrefix.trim()}@${vm.domainAddress.trim()}`;
      } else {
        vm.user.loginName = '';
      }
    } else if (vm.loginNamePrefix.trim() !== '' && vm.domainAddress.trim() !== '') {
      vm.user.loginName = `${vm.loginNamePrefix.trim()}@${vm.domainAddress.trim()}`;
      vm.user.emailAddress = vm.user.loginName;
    } else {
      vm.user.loginName = '';
      vm.user.emailAddress = '';
    }
  }

  function _handleEmailAddressChange() {
    if (vm.emailAddressPrefix.trim() !== '' && vm.emailDomainAddress.trim() !== '') {
      vm.user.emailAddress = `${vm.emailAddressPrefix.trim()}@${vm.emailDomainAddress.trim()}`;
    } else {
      vm.user.emailAddress = '';
    }
  }

  function parseEmailAddress(email) {
    if (email) {
      const i = email.indexOf('@');
      if (i !== -1) {
        vm.emailAddressPrefix = email.substring(0, i);
        vm.emailDomainAddress = email.substring(i + 1);

        const emailFind = R.find(R.propEq('domain', vm.emailDomainAddress), vm.customerDomains);

        if (!emailFind) {
          vm.emailDomainAddress = vm.customerDomains[0].domain;
        }
      }
    }
  }

  function parseLoginName(loginName) {
    if (loginName) {
      const i = loginName.indexOf('@');
      if (i !== -1) {
        vm.loginNamePrefix = loginName.substring(0, i);
        vm.domainAddress = loginName.substring(i + 1);

        const loginFind = R.find(R.propEq('domain', vm.domainAddress), vm.customerDomains);

        if (!loginFind) {
          vm.domainAddress = vm.customerDomains[0].domain;
        }
      }
    }
  }
}

EditUserDialogController.$inject = [
  '$rootScope',
  '$scope',
  'alerts',
  'confirmDialog',
  'ssDialogService',
  'loaderService',
  'userService',
  'orgDataService',
];
